<template>
  <mds-layout-grid class="hypo-type">
    <mds-row v-if="types.length > 0" align-horizontal="center">
      <mds-col>
        <mds-card
          v-for="item in types"
          :key="item.type"
          :e2e="`hypo-type-${item.type}`"
          class="hypo-type__card"
          :data-hypo-type="item.type"
          :title="item.label"
          :caption="item.description"
          :heading-level="2"
          href="#"
          full-bleed
          @click.native.prevent="handleSelectType"
        >
          <template v-slot:mds-card-supplemental-content>
            <component :is="images[item.id]"></component>
          </template>
        </mds-card>
      </mds-col>
    </mds-row>
  </mds-layout-grid>
</template>

<script>
import MwcVueHelperMixin, { MwcConfigMixin } from 'mwc-vue-component-helper';
import { MdsLayoutGrid, MdsRow, MdsCol } from '@mds/layout-grid';
import MdsCard from '@mds/card';
import defaultConfig from './_config';
import PortfolioImage from './assets/SinglePortfolioImage';
import PortfolioCImage from './assets/PortfolioCImage';
import InvestmentImage from './assets/investmentImage';

export default {
  name: 'hypo-type',
  components: {
    MdsLayoutGrid,
    MdsRow,
    MdsCol,
    MdsCard,
    [PortfolioImage.name]: PortfolioImage,
    [PortfolioCImage.name]: PortfolioCImage,
    [InvestmentImage.name]: InvestmentImage,
  },
  mixins: [MwcVueHelperMixin, MwcConfigMixin],
  props: {
    mwcId: {
      type: String,
      required: true,
    },
    config: {
      type: [String, Object],
      default: () => {},
    },
    types: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      defaultConfig: {
        intlNamespace: this.mwcId,
        ...defaultConfig,
      },
      images: {
        PORTFOLIO: PortfolioImage.name,
        PORTFOLIO_C: PortfolioCImage.name,
        INDVIL_H: InvestmentImage.name,
      },
    };
  },
  computed: {
    labels() {
      return {
        portfolio: this.translate('portfolio'),
        portfolioComparison: this.translate('portfolioComparison'),
        investment: this.translate('investment'),
        investmentComparison: this.translate('investmentComparison'),
        portfolioDescription: this.translate('portfolioDescription'),
        portfolioComparisonDescription: this.translate('portfolioComparisonDescription'),
        investmentDescription: this.translate('investmentDescription'),
        investmentComparisonDescription: this.translate('investmentComparisonDescription'),
      };
    },
  },
  methods: {
    handleSelectType(e) {
      const el = e.currentTarget;
      this.$emit('select-type', el.dataset.hypoType);
    },
  },
};
</script>

<style lang="scss">
@import '~@mds/constants';
@import '~@mds/typography';
@import './styles/variables';

.hypo-type {
  margin-top: $mds-space-3-x;
}

.#{$component-ns} {
  background-color: $mds-background-color-white;

  &__card {
    height: 235px;
    //height: 260px; further implementation
    margin-right: 16px;
    width: 230px;
    //width: 32%; further implementation
    transition: 0.25s;
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      box-shadow: 0 1px 4px hsla(0, 0%, 50%, 0.5);
      transform: translateY(-5px);
      .mds-card__supplemental-content___hypo {
        transform: scale(1.05);
        transition: 0.4s;
      }
    }
    &.disabled {
      cursor: not-allowed;
      opacity: 0.3;
    }

    &:focus.disabled {
      box-shadow: none;
    }

    .mds-card__title___hypo {
      @include mds-level-6-heading($bold: true);
      font-size: $mds-typography-font-size-m;
    }

    .mds-card__caption___hypo {
      @include mds-body-text-s();
      height: 54px;
    }

    .mds-card__supplemental-content___hypo {
      margin-bottom: 0;
    }
    .mds-card__action___hypo {
      display: none;
    }
  }

  &--single,
  &--comparison,
  &--investment,
  &--investment-comparison {
    width: 100%;
    height: 120px;
    opacity: 0.3;
  }

  &--single {
    background-color: $mds-chart-color-15;
    // background-image: url('portfolio.svg');
  }

  &--comparison {
    background-color: $mds-chart-color-4;
    // background-image: url('/assets/portfolio_comparison.svg');
  }

  &--investment {
    background-color: $mds-chart-color-3;
    // background-image: url('/assets/investment.svg');
  }

  &--investment-comparison {
    background-color: $mds-chart-color-12;
    // background-image: url('/assets/investment_comparison.svg');
  }
}
</style>
